export default "__VITE_ASSET__BEXHlH$k__"